module.exports = __webpack_public_path__ + "media/stylesheets/images/temp_wolf_planent_kit/card_kit_6-15b0ed6b868c0d34be3311757bcde1a9.png";